import React from "react";
import { connect } from "react-redux";
import style from "./Header.module.scss";
import onClickOutside from "react-onclickoutside";
import { Avatar } from '@material-ui/core';
import getInitials from '../../helpers/getNameInitials'

function LoggedUserInfo(props) {
  LoggedUserInfo.handleClickOutside = () => {
    props.handleClose();
  };

  return (
    <div className={style.LogoWrapper} onClick={props.displayHandler}>
      {(props.me.user && props.me.user.file_url) ? (
        <img src={props.me.user.file_url} />
      )
      :
      (
        <Avatar style = {{ width: '35px', height: '35px' }}>
          {getInitials(props.me.user.name)}
        </Avatar>
      )
    }
    </div>
  );
}

const mapStateToProps = state => {
  return {
    me: state.auth.me
  };
};

const clickOutsideConfig = {
  handleClickOutside: () => LoggedUserInfo.handleClickOutside
};

export default connect(mapStateToProps)(
  onClickOutside(LoggedUserInfo, clickOutsideConfig)
);
